import React from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import Banner from '../banner/index.jsx';
import boots from './boot.js';
import coverall from './coverall.js';
import eyewear from './eyewear.js';
import gloves from './glove.js';
import hats from './hat.js';
import masks from './mask.js';
import road from './road.js';
import './productlist.css';

const ProductList = () => {
    const { id } = useParams();
    let productList;
    // Set bannerSrc, bannerAlt, and productList based on id
    switch (id) {
        case 'boots':
            productList = boots;
            break;
        case 'coverall':
            productList = coverall;
            break;
        case 'eyewear':
            productList = eyewear;
            break;
        case 'gloves':
            productList = gloves;
            break;
        case 'hats':
            productList = hats;
            break;
        case 'masks':
            productList = masks;
            break;
        case 'roadsafety':
            productList = road;
            break;
        default:
            productList = [boots, coverall, eyewear, gloves, hats, masks, road];
            break;
    }
    const truncate = (text, maxLength) => {
      if (text.length <= maxLength) {
        return text;
      }
      return text.substring(0, maxLength) + '...';
    };
    return (
      <div className="product-list">
        <Banner id={id} />
        <Container>
          <Row className='mt-5'>
            <Col className='mb-5' md={3}>
              <h2 className='category-heading'>PPE Categories</h2>
              <ul className='products-categories'>
                <li><a className='category' href="/product/boots">Boots</a></li>
                <li><a className='category' href="/product/coverall">Coverall</a></li>
                <li><a className='category' href="/product/eyewear">Eyewear</a></li>
                <li><a className='category' href="/product/gloves">Gloves</a></li>
                <li><a className='category' href="/product/hats">Hats</a></li>
                <li><a className='category' href="/product/masks">Masks</a></li>
                <li><a className='category' href="/product/roadsafety">Road Safety</a></li>
              </ul>
            </Col>
            <Col className='mb-5'>
              <Row>
                {productList.map((product) => (
                  <>
                    {product.subcategory?<h2 id={product.sublink} className='product-subcategory'>{product.subcategory}</h2>:''}
                  <Col className='border' key={product?.id} md={4}>
                        <div className="product">
                            <center>
                              <img className='product-image' src={product?.image} alt={product?.alt} />
                              <h3 className='product-label'>{product?.label}</h3>
                            </center>
                            <p>{truncate(product.description, 150)}</p>
                        </div>
                  </Col>
                  </>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
};

export default ProductList;
